import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Quotes, ArrowLeft, ArrowRight, Star } from "@phosphor-icons/react";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  const t = items[idx];
  const next = () => setIdx((i) => (i + 1) % items.length);
  const prev = () => setIdx((i) => (i - 1 + items.length) % items.length);

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-20 md:py-32 px-5 md:px-10 lg:px-16"
    >
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-4">
          <p className="section-num mb-3">05 — Word of mouth</p>
          <h2 className="font-display text-5xl md:text-6xl uppercase tracking-tighter leading-[0.92]">
            What<br />Melbourne<br />says.
          </h2>
        </div>

        <div className="col-span-12 md:col-span-8">
          <Quotes size={64} weight="fill" className="text-[#D85C3A] mb-4" />
          <p
            key={t.id}
            data-testid="testimonial-text"
            className="font-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.05] uppercase slide-up"
          >
            "{t.text}"
          </p>
          <div className="mt-6 flex items-center gap-1">
            {[...Array(t.rating)].map((_, i) => (
              <Star key={i} size={18} weight="fill" className="text-[#D85C3A]" />
            ))}
          </div>
          <div className="mt-3 flex items-end justify-between border-t-2 border-[#111] pt-4">
            <div>
              <div className="font-bold text-lg">{t.name}</div>
              <div className="text-xs uppercase tracking-widest text-[#666]">{t.suburb}, Melbourne</div>
            </div>
            <div className="flex gap-2">
              <button
                data-testid="testimonial-prev"
                onClick={prev}
                aria-label="previous"
                className="border-2 border-[#111] p-3 hover:bg-[#111] hover:text-[#F2F2EF] transition-colors"
              >
                <ArrowLeft size={18} weight="bold" />
              </button>
              <button
                data-testid="testimonial-next"
                onClick={next}
                aria-label="next"
                className="border-2 border-[#111] p-3 hover:bg-[#D85C3A] hover:text-white hover:border-[#D85C3A] transition-colors"
              >
                <ArrowRight size={18} weight="bold" />
              </button>
            </div>
          </div>
          <div className="text-xs uppercase tracking-widest text-[#666] mt-4">
            {idx + 1} / {items.length}
          </div>
        </div>
      </div>
    </section>
  );
}
